// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"2c8a405c","205":"1ed53330","323":"e01ff3a5","776":"f1330ee0","822":"adb54ad8"}[chunkId] + ".chunk.js";
};